import React from "react";
import { Link } from "react-router-dom";
import { SVVInformationMessage } from "@komponentkassen/svv-information-message";
import { useApptekster } from "../../apptekst-context";
import {SVVButtonCustom} from "@komponentkassen/svv-button";

const ReconfirmConfirmation = () => {
  const t = useApptekster();

  return (
    <>
      <div className="svv-padding-vertical--px32">
        <SVVInformationMessage type="success">
          <p id="sendt-ny-bekreftelse">
            {t("timebestilling.sendt-ny-bekreftelse")}
          </p>
        </SVVInformationMessage>
      </div>
      <p className="spacing-bottom--medium">
        {t("timebestilling.resend-confirmation-paragraf")}
      </p>
      <SVVButtonCustom asElement={Link} href="/" hrefAttribute="to">
        {t("timebestilling.tilbake-til-timebestilling")}
      </SVVButtonCustom>
    </>
  );
};

export default ReconfirmConfirmation;
